import { CurrencyCode } from '../types';

/**
 * Returns the currency symbol for a given currency type.
 * @param {CurrencyCode} currency - The currency type
 * @returns {string} The corresponding currency symbol
 */
export const defineCurrencySymbol = (
    currency: CurrencyCode
): string => {
    switch (currency) {
        case 'AMD':
            return '֏';
        case 'AZN':
            return '₼';
        case 'EUR':
            return '€';
        case 'INR':
            return '₹';
        case 'KGS':
            return 'с';
        case 'KZT':
            return '₸';
        case 'USD':
        case 'MXN':
        case 'CLP':
        case 'ARS':
        case 'XTS':
        case 'COP':
            return '$';
        case 'PEN':
            return 'S/.';
        case 'RUB':
        case 'RUR':
            return '₽';
        case 'UAH':
            return '₴';
        case 'UZS':
            return 'Soʻm';
        case 'BRL':
            return 'R$';
        case 'Bonuses':
        case 'Undefined':
        default:
            return '';
    }
}
